import classnames from 'classnames'
import { ROLES } from '../../index'
import ImagePreview from './image-preview'
import VideoPreview from './video-preview'
import Downloadable from './downloadable'

const fileTypes = {
  image: 'image',
  video: 'video',
}

export default function File({ type, size, role, fileKey, url }) {
  const [fileTypeIdentifier] = type?.split('/') || []
  const fileType = fileTypes[fileTypeIdentifier] || fileTypeIdentifier

  return (
    <div
      className={classnames('wrapper', {
        sent: role === ROLES.sender,
      })}
    >
      {fileType === fileTypes.image ? (
        <ImagePreview src={fileKey} />
      ) : fileType === fileTypes.video ? (
        <VideoPreview url={url} type={type} />
      ) : (
        <Downloadable url={url} size={size} fileType={fileType} />
      )}

      <style jsx>{`
        .wrapper {
          width: fit-content;
          background: var(--secondary-input-bg);
          border-radius: 1rem;

          &.sent {
            margin: 0.6rem 0 0 auto;
            background: #d7e8fd;
          }
        }
      `}</style>
    </div>
  )
}
